import { Fragment, useEffect, useState, useRef } from "react";

import { useNavigate } from "react-router-dom";
import Papa from "papaparse";
import * as XLSX from "xlsx";

// ** MUI Components
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import MuiCard from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { styled } from "@mui/material/styles";
import FormHelperText from "@mui/material/FormHelperText";
import Tooltip from "@mui/material/Tooltip";
import { DataGrid } from "@mui/x-data-grid";
import { DataGridPro } from '@mui/x-data-grid-pro';
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuList from "@mui/material/MenuList";
import ButtonGroup from "@mui/material/ButtonGroup";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import MuiTabList from "@mui/lab/TabList";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import Avatar from "@mui/material/Avatar";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

// ** Custom Cumponent Imports
import CustomTextField from "../../../../components/mui/text-field";
import ServerSideToolbar_WithoutSearch from "../../../../components/data-grid/ServerSideToolbar_WithoutSearch";
import AddEmployeeDialog from "screens/Employees/component/AddEmployee";

// ** Icon Imports
import Icon from "../../../../components/icon";
import AddIcon from "@mui/icons-material/Add";
import AddEmployeeDoodle from "images/AddEmployeeDoodle.png";
import XLSX_Placeholder from "images/Attachment_Icons/XLSX__PlaceholderIcon.png";
import CSV_Placeholder from "images/Attachment_Icons/CSV__PlaceholderIcon.png";

// ** Third Party Components
import { ToastContainer, toast } from "react-toastify";
import { useDropzone } from "react-dropzone";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { GetEmployees } from "screens/Employees/logic/GetEmployees";
import { filterData, filterDataOnboarding } from "screens/Employees/logic/filterData";
import { DeleteEmployee } from "screens/Employees/logic/DeleteEmployee";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { dev_baseUrl } from "utils/var";

const MySwal = withReactContent(Swal);


// ** Styled Components
const Card = styled(MuiCard)(({ theme }) => ({
  [theme.breakpoints.up("sm")]: { width: "100%" },
}));

const TabList = styled(MuiTabList)(({ theme }) => ({
  borderBottom: "0 !important",
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  "&, & .MuiTabs-scroller": {
    boxSizing: "content-box",
    padding: theme.spacing(1.25, 1.25, 2),
    margin: `${theme.spacing(-1.25, -1.25, -2)} !important`,
    backgroundColor: '#F3F4F4',
    maxWidth: 'max-content',
    borderRadius: theme.shape.borderRadius,
    display: 'flex',
    justifyContent: 'center',
    // Responsive padding for mobile
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1, 1, 1.5),
      margin: `${theme.spacing(-1, -1, -1.5)} !important`,
    }
  },
  "& .MuiTabs-flexContainer": {
    justifyContent: 'center',
    // Reduce gap between tabs on mobile
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(0.5),
    }
  },
  "& .MuiTabs-indicator": {
    display: "none",
  },
  "& .Mui-selected": {
    boxShadow: theme.shadows[2],
    backgroundColor: theme.palette.common.white,
    color: `${theme.palette.main.main} !important`,
  },
  "& .MuiTab-root": {
    display: 'flex',
    justifyContent: 'center',
    lineHeight: 1,
    borderRadius: theme.shape.borderRadius,
    // Smaller padding and min-height for mobile
    [theme.breakpoints.down('sm')]: {
      minHeight: '36px',
      padding: theme.spacing(0.75, 1.5),
      fontSize: '0.8rem',
    },
    "&:hover": {
      color: theme.palette.primary.main,
    },
  },
}));

const StepAddEmployee = ({ handlePrev, handleNext }) => {
  // ** Hooks
  const theme = useTheme();

  // ** States
  const [files, setFiles] = useState([]);
  const [alignment, setAlignment] = useState("enterManually");
  const [dataEntryAlignment, setDataEntryAlignment] = useState("enterManually");

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [rows, setRows] = useState([]);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [fileLoading, setFileLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [openErrorListDlg, setOpenErrorListDlg] = useState(false);
  const [openSuccessListDlg, setOpenSuccessListDlg] = useState(false);
  const [openErrorImport, setOpenErrorImport] = useState(false);
  const [selectedIndexErrorImport, setSelectedIndexErrorImport] = useState(1);
  const [errorMessages, setErrorMessages] = useState([]);
  const [successMessages, setSuccessMessages] = useState("");
  const [isDataModified, setIsDataModified] = useState(false);
  const [isIntentionalNavigation, setIsIntentionalNavigation] = useState(false);
  const [openAddEmpDlg, setOpenEmpDlg] = useState(false);
  const [displayBanner, setDisplayBanner] = useState(true);
  const [employeePaginationModel, setEmployeePaginationModel] = useState({
    page: 0,
    pageSize: 10
  })

  const optionsErrorImport = ["Export report as CSV", "Export report as XLSX"];

  const anchorRefErrorImport = useRef(null);

  const handleClickErrorImport = () => {
    console.info(`You clicked ${optionsErrorImport[selectedIndexErrorImport]}`);
  };

  const handleOpenAddEmpDlg = () => setOpenEmpDlg(true);
  const handleCloseAddEmpDlg = () => setOpenEmpDlg(false);

  const handleMenuItemClickErrorImport = (event, index) => {
    setSelectedIndexErrorImport(index);
    setOpenErrorImport(false);
  };

  const handleToggleErrorImport = () => {
    setOpenErrorImport((prevOpen) => !prevOpen);
  };

  const handleCloseErrorImport = () => {
    setOpenErrorImport(false);
  };

  const navigate = useNavigate();

  const handleAlignment = (event, newAlignment) => {
    if (newAlignment != null) {
      setAlignment(newAlignment);
      setDataEntryAlignment(newAlignment);
    }
  };

    const handleNextPage = () => {
     handleNext();
    };

  const handlePrevious = () => {
  handlePrev();
};

  useEffect(() => {
    if (message || Object.keys(errors).length > 0) {
      const timer = setTimeout(() => {
        setMessage("");
        setErrors({});
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [message, errors]);

  useEffect(() => {}, [loading, rows]);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (isDataModified || rows.length > 0) {
        e.preventDefault();
        e.returnValue = "";
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [isDataModified, rows]);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (isDataModified || rows.length > 0) {
        e.preventDefault();
        e.returnValue = "";
      }
    };

    const handlePopState = () => {
      if (isDataModified || rows.length > 0) {
        const shouldNavigate = window.confirm(
          "Are you sure you want to go back? Your changes might not be saved."
        );
        if (!shouldNavigate) {
          window.history.pushState(null, "", window.location.href);
        }
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handlePopState);
    };
  }, [isDataModified, rows]);

  // ** Dropzone configuration
  const { getRootProps, getInputProps } = useDropzone({
    maxFiles: 1,
    maxSize: 2000000, // 2 MB in bytes
    accept: {
      "text/csv": [".csv"],
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
        ".xlsx",
      ],
    },
    onDrop: (acceptedFiles) => {
      setLoading(true);
      setTimeout(() => {
        setFiles(acceptedFiles.map((file) => Object.assign(file)));
        setIsDataModified(true);
        setLoading(false);
      }, 1000);
    },
    onDropRejected: () => {
      toast.error("You can only upload 1 file with a maximum size of 2 MB.", {
        duration: 2000,  
        style: {
          fontFamily: '"DM Sans", sans-serif',
          fontSize: '15px',
        },
          });
      // setMessage("You can only upload 1 file with a maximum size of 2 MB.");
      setLoading(false);
    },
  });

  const handleFileParse = async () => {
    const file = files[0];
    if (!file) {
      setMessage("Please select file to perform this action.");
      return;
    }

    let parsedData = [];

    const renameKeys = (data) => {
      return data.map((row) => {
        const newRow = {};
        const keyGroups = {};

        for (let key in row) {
          const match = key.match(/(.+)_([0-9]+)/);
          if (match) {
            const baseKey = match[1];
            const number = parseInt(match[2]);

            if (!keyGroups[baseKey]) {
              keyGroups[baseKey] = [];
            }
            keyGroups[baseKey].push(number);
          } else {
            keyGroups[key] = [0];
          }
        }

        for (let key in row) {
          const match = key.match(/(.+)_([0-9]+)/);
          if (match) {
            const baseKey = match[1];
            const number = parseInt(match[2]);

            const numbers = keyGroups[baseKey].sort((a, b) => a - b);
            const isValidSequence = numbers.every(
              (num, index) => num === index
            );

            if (isValidSequence) {
              newRow[`${baseKey}_${number + 1}`] = row[key];
            } else {
              newRow[key] = row[key];
            }
          } else {
            newRow[key] = row[key];
          }
        }
        return newRow;
      });
    };

    if (file.type === "text/csv") {
      Papa.parse(file, {
        skipEmptyLines: true,
        header: true,
        complete: (result) => {
          parsedData = renameKeys(result.data);
          navigateToNextPage(parsedData);
          setLoading(false);
        },
      });
    } else if (
      file.type ===
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        // Parse with header row and default value for empty cells
        let dataRows = XLSX.utils.sheet_to_json(worksheet, {
          header: 1,
          defval: "",
        });

        // Extract headers and map rows
        const headers = dataRows[0];
        const rows = dataRows.slice(1).map((row) =>
          headers.reduce((acc, key, i) => {
            acc[key] = row[i] || "";
            return acc;
          }, {})
        );

        parsedData = renameKeys(rows);
        navigateToNextPage(parsedData);
        setLoading(false);
      };
      reader.readAsArrayBuffer(file);
    }

    // if (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
    //   const reader = new FileReader()
    //   reader.onload = (e) => {
    //     const data = new Uint8Array(e.target.result)
    //     const workbook = XLSX.read(data, { type: 'array' })
    //     const sheetName = workbook.SheetNames[0]
    //     const worksheet = workbook.Sheets[sheetName]
    //     parsedData = XLSX.utils.sheet_to_json(worksheet)
    //     parsedData = renameKeys(parsedData)
    //     navigateToNextPage(parsedData)
    //     setLoading(false);
    //   }
    //   reader.readAsArrayBuffer(file)
    // }
  };

  const navigateToNextPage = (data) => {
    navigate("/onboarding/add-employee", { state: { data } });
  };

  // Render file preview
  const renderFilePreview = (file) => {
    if(file.type === "text/csv"){
      return <img src={CSV_Placeholder} />
    }else{
      return <img src={XLSX_Placeholder} />
    }
  };

  // Handle file removal
  const handleRemoveFile = (file) => {
    const filteredFiles = files.filter((i) => i.name !== file.name);
    setFiles(filteredFiles);
  };

  const [AllEmployees, setAllEmployees] = useState([]);
  const keysToKeep = [
    'employeeID',
    'empType',
    'firstName',    
    'roleName',
    'phoneNumbers',    
    'email',
  ];

  const fetchEmployees = async () => {
    setLoading(true);
    try {
      let emp = await GetEmployees(0, navigate);
      const filteredDataNew = filterDataOnboarding(emp, keysToKeep);
      setRows(filteredDataNew);
      setAllEmployees(emp);
    } catch (error) {
      console.error("Error fetching employee data:", error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchEmployees();
  },[]);

  const columns = [
    {
      flex: 0.1,
      field: "Fullname",
      minWidth: 140,
      editable: true,
      headerName: "Fullname",
    },    
    {
      flex: 0.1,
      minWidth: 160,
      field: "email",
      editable: true,
      headerName: "Email",
    },
    {
      flex: 0.1,
      minWidth: 160,
      field: "phone",
      editable: false,
      headerName: "Phone",
    },
    {
      flex: 0.1,
      minWidth: 140,
      field: "roleName",
      headerName: "Role",
      renderCell: (params) => {
        const { row } = params;
  
        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
            <Typography noWrap variant="body1">
              {
                row.roleName === 'CrewMember' ? 
                'Crew Member' : 
                row.roleName === 'OfficeManager' ? 
                'Office Manager' : 
                row.roleName === 'CrewLeader' ?
                'Crew Leader' :
                row.roleName
              }
            </Typography>
          </Box>
        );
      },
    },
    {
      flex: 0.1,
      minWidth: 140,
      field: "empType",
      editable: false,
      headerName: "Type",
    },
    {
      field: "actions",
      headerName: "Actions",
      minWidth: 120,
      maxWidth: 120,
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <IconButton
            onClick={() => handleDeleteEmployee(params.id)}
            color="error"
          >
            <Icon icon="tabler:trash" />
          </IconButton>
        </Box>
      ),
    },
  ];
  const errorColumns = [
    {
      flex: 0.25,
      minWidth: 180,
      field: "email",
      headerName: "Email",
    },
    {
      flex: 0.25,
      minWidth: 180,
      headerName: "Reason",
      field: "failureReason",
    },
  ];

  const validateName = (name, field) => {
    const errors = {};
    const forbiddenKeywords = ["Select", "Update", "Delete", "INSERT", "Drop"];

    const nameRegex = /^[A-Za-z\s'-]+$/;
    if (!nameRegex.test(name)) {
      errors[field] = `${
        field === "firstName" ? "First" : "Last"
      } Name cannot contain special characters.`;
    }

    if (
      forbiddenKeywords.some((word) =>
        name.toLowerCase().includes(word.toLowerCase())
      )
    ) {
      errors[field] = `Invalid Input.`;
    }

    if ((name && name.trim().length) < 2 || (name && name.trim().length) > 50) {
      errors[field] = `${
        field === "firstName" ? "First" : "Last"
      } Name must be between 2 and 50 characters.`;
    }

    if (!name.trim()) {
      errors[field] = `${
        field === "firstName" ? "First" : "Last"
      } Name cannot be empty or only spaces.`;
    }

    if (!name) {
      errors[field] = `${
        field === "firstName" ? "First" : "Last"
      } Name is required.`;
    }

    return errors;
  };

  const handleAddEmployee = () => {
    const newErrors = {};

    // Apply validation for First Name
    const firstNameErrors = validateName(firstName, "firstName");
    if (Object.keys(firstNameErrors).length > 0) {
      newErrors.firstName = firstNameErrors.firstName;
    }

    // Apply validation for Last Name
    const lastNameErrors = validateName(lastName, "lastName");
    if (Object.keys(lastNameErrors).length > 0) {
      newErrors.lastName = lastNameErrors.lastName;
    }
    if (!email) {
      newErrors.email = "Email is required.";
    }

    if (!phone || phone.trim() === "") {
      newErrors.phone = "Phone number is required";
    } else if (phone.length < 10) {
      newErrors.phone = "Invalid phone number.";
    } else if (phone.charAt(0) === "1") {
      newErrors.phone = "Area code cannot begin with 1.";
    } else if (phone.length === 10) {
    } else {
      newErrors.phone = "Phone number should be 10 digits";
    }

    // Email validation (simple regex)
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email && !emailRegex.test(email)) {
      newErrors.email = "Please enter a valid email.";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      return;
    }
    // Add the employee to the grid
    const newEmployee = {
      id: rows.length + 1,
      firstName,
      lastName,
      email,
      phone,
    };

    setRows([...rows, newEmployee]);

    // For page reload
    setIsDataModified(true);

    // Clear input fields
    setFirstName("");
    setLastName("");
    setEmail("");
    setPhone("");
  };

 const handleDeleteEmployee = (id) => {
  MySwal.fire({
    title: '<strong>Are you sure?</strong>',
    html: "<span>You won't be able to revert this!</span>",
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'No, keep it',
    width: '390px',
    padding: '1rem',
    focusConfirm: false,
    showCloseButton: true,
    closeButtonHtml: '&times;',
    customClass: {
      popup: theme.palette.mode === 'dark' ? 'custom-swal-popup-dark' : 'custom-swal-popup',
          title: theme.palette.mode === 'dark' ? 'custom-swal-title-dark' : 'custom-swal-title',
          htmlContainer: 'custom-swal-html',
          confirmButton: 'custom-swal-confirm',
          cancelButton: theme.palette.mode === 'dark' ? 'custom-swal-cancel-dark' : 'custom-swal-cancel',
          closeButton: 'custom-swal-close'
    }
  }).then(async (result) => {
    if (result.isConfirmed) {
      const res = await DeleteEmployee(id, navigate);
      if (res) {
        const updatedRows = rows.filter((row) => row.id !== id);
        setRows(updatedRows);
        toast.success("Employee deleted successfully.", {
          style: {
            fontFamily: '"DM Sans", sans-serif',
            fontSize: '15px',
          },
        });
            } else {
              toast.error("Failed to delete employee.", {
                style: {
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: '15px',
                },
              });
            }
          }
  });
};


  const handleSaveEmployees = async () => {
    setIsIntentionalNavigation(true);
    const token = localStorage.getItem("jwtToken");

    if (!token) {
      // If there's no token, redirect to login page
      setLoading(true);
      navigate("/login", {
        state: { message: "Session expired, please login again." },
      });
      return;
    }

    if (rows.length <= 0) {
      setMessage("Atleast one employee is required to perform this action.");
      return;
    }

    for (const row of rows) {
      if (!row.firstName) {
        setMessage(`Please fill in First Name in row: ${row.id}`);
        return;
      }
      if (!row.lastName) {
        setMessage(`Please fill in Last Name in row: ${row.id}`);
        return;
      }
      if (!row.email) {
        setMessage(`Please fill in Email in row: ${row.id}`);
        return;
      }

      // Email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (row.email && !emailRegex.test(row.email)) {
        setMessage(`Please enter a valid email in row: ${row.id}`);
        return;
      }
    }

    const apiPayload = rows.map((row) => {
      const phoneValue = row.phone || null;
      const isInvalidPhone =
        !phoneValue ||
        phoneValue.trim() === "" ||
        phoneValue.length < 10 ||
        phoneValue === "1" ||
        phoneValue.length !== 10;

      return {
        isActive: true,
        employeeID: 0,
        firstName: row.firstName || null,
        lastName: row.lastName || null,
        email: row.email || null,
        phoneNumbers: [
          {
            phoneNo: isInvalidPhone ? null : `1${phoneValue}` || null,
            isPrimary: isInvalidPhone ? false : true || null,
          },
        ],
        empType: "Employees",
        companyID: 0,
        userID: 0,
        position: null,
        title: null,
        dateOfBirth: "1900-01-01",
        referredBy: null,
        address: null,
        city: null,
        stateProvince: null,
        postalCode: null,
        country: null,
        emergencyContactName: null,
        emergencyContactRelationship: null,
        emergencyContactPhone: null,
        hireDate: "1900-01-01",
        employmentStatus: null,
        departmentID: 0,
        jobTitle: null,
        probationEndDate: "1900-01-01",
        drivingLicenseValid: false,
        drivingLicenseExpiryDate: "1900-01-01",
        wageAmount: 0,
        wageType: null,
        clockInOutRequired: false,
      };
    });

    setLoading(true);
    try {
      const response = await fetch(
        `${dev_baseUrl}/Employee/save`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(apiPayload),
        }
      );

      if (response.status === 400) {
        // Handle validation error
        const errorResponse = await response.json();
        console.error("Validation Error:", errorResponse);

        // Extract error details
        const validationErrors = errorResponse.errors || {};
        const errorMessages_1 = Object.keys(validationErrors).map((key) => {
          const errorList = validationErrors[key].join(", ");
          return `${key}: ${errorList}`;
        });

        // setErrorDetails(errorMessages);
        setMessage("Validation errors occurred. Please check your input.");
        return;
      }

      if (response.status === 401) {
        // Token is invalid or expired, redirect to login
        navigate("/login", {
          state: { message: "Session expired, please login again." },
        });
        return;
      }

      if (!response.ok) {
        const errorMessage = `Error ${response.status}: ${response.statusText}`;
        console.error(errorMessage);
        setMessage("Failed to save employee data. Please try again.");
      }

      const result = await response.json();

      if (result.isError) {
        const failureMessages = result.result
          .filter((item) => item.failureReason)
          .map(
            (item) =>
              `${item.firstName} ${item.lastName}: ${item.failureReason}`
          );

        if (failureMessages.length > 0) {
          const errorMessagesWithIds = result.result.map((row, index) => ({
            ...row,
            id: index,
          }));

          setErrorMessages(errorMessagesWithIds);
          setOpenErrorListDlg(true);
          return;
        }
      }
      // setMessage('Data saved successfully!');
      sessionStorage.setItem("myStep", 3);
      setSuccessMessages(
        result?.message || "All employees saved successfully."
      );
      setOpenSuccessListDlg(true);
      // navigate('/onboarding', { state: { message: result?.message || 'All employees saved successfully.' } });
    } catch (error) {
      console.error("Error:", error);
      setMessage("An error occurred while saving data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleProcessRowUpdate = (newRow, oldRow) => {
    const updatedRows = rows.map((row) =>
      row.id === oldRow.id ? newRow : row
    );
    setRows(updatedRows);
    return newRow;
  };

  const handleOpenErrorListDlg = () => {
    setOpenErrorListDlg(true);
  };

  const handleCloseErrorListDlg = () => {
    setOpenErrorListDlg(false);
    navigate("/onboarding");
  };

  const handleCloseSuccessListDlg = () => {
    setOpenSuccessListDlg(false);
    navigate("/onboarding");
  };

  // File list component
  const fileList = files.map((file) => (
    <Box
      key={file.name}
      sx={{
        border: '1px solid #E1E4EA',
        borderRadius: 1,
        px: 6,
        py: 4,
        mx: 'auto',
        minWidth: {xs: 250, sm: 300},
        maxWidth: 'max-content',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            mr: 6,
          }}
        >
          <Box>
            {renderFilePreview(file)}
          </Box>
          <Box>
            <Tooltip title={file.name}>
              <Typography 
                variant='body1'
                sx={{
                  maxWidth: '300px',
                  whiteSpace: {xs: 'wrap', sm: 'nowrap'},
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: 'inline-block'
                }}
              >
                {file.name}
              </Typography>
            </Tooltip>
            <Typography variant='body1' color='text.secondary'>
              {Math.round(file.size / 100) / 10 > 1000
                ? `${(Math.round(file.size / 100) / 10000).toFixed(1)} mb`
                : `${(Math.round(file.size / 100) / 10).toFixed(1)} kb`}
            </Typography>
          </Box>
        </Box>
        <Tooltip title='Remove'>
          <IconButton
           onClick={() => handleRemoveFile(file)}
           color="error"
           >
            <Icon icon="tabler:trash" />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
    // <ListItem key={file.name}>
    //   <div className="file-details">
    //     <div className="file-preview">{renderFilePreview(file)}</div>
    //     <div>
    //       <Typography className="file-name">{file.name}</Typography>
    //       <Typography className="file-size" variant="body2">
    //         {Math.round(file.size / 100) / 10 > 1000
    //           ? `${(Math.round(file.size / 100) / 10000).toFixed(1)} mb`
    //           : `${(Math.round(file.size / 100) / 10).toFixed(1)} kb`}
    //       </Typography>
    //     </div>
    //   </div>
    //   <IconButton onClick={() => handleRemoveFile(file)}>
    //     <Icon icon="tabler:x" fontSize={20} />
    //   </IconButton>
    // </ListItem>
  ));

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          my: 5,
        }}
      >
        {message && (
          <Box mb={2} textAlign="center">
            <Typography
              variant="h6"
              color={message.includes("successfully") ? "green" : "red"}
            >
              {message}
            </Typography>
          </Box>
        )}
        <Grid container spacing={5}>
        <Grid item xs={12}>
  <Box
    sx={{
      display: "flex",
      flexDirection: { xs: "column", sm: "row" }, // Stack on mobile
      justifyContent: "space-between",
      alignItems: { xs: "flex-start", sm: "center" }, // Left align on mobile
      maxWidth: { xs: "100%", lg: "60%" },
 
      mx: "auto",
      gap: { xs: 3, sm: 0 } // Add gap between stacked items
    }}
  >
    <Box sx={{ 
      display: "flex", 
      alignItems: "center", 
      gap: 2,
      flexDirection: { xs: "column", sm: "row" }, // Stack avatar and text on mobile
      textAlign: { xs: "center", sm: "left" } // Center text on mobile
    }}>
      <Avatar
        sx={{
          bgcolor: "white",
          border: "1px solid #e0e0e0",
          color: "text.primary",
          height: { xs: 40, sm: 50 }, // Smaller on mobile
          width: { xs: 40, sm: 50 }, // Smaller on mobile
          mb: { xs: 1, sm: 0 } // Add bottom margin on mobile
        }}
      >
        <Icon icon="tabler:users" />
      </Avatar>
      <Box>
        <Typography variant="h5" sx={{ fontSize: { xs: "1.25rem", sm: "1.25rem" } }}>
          Add Employees
        </Typography>
        <Typography sx={{ 
          color: "text.secondary",
          fontSize: { xs: "0.875rem", sm: "0.9rem" } // Smaller font on mobile
        }}>
          Time to get your Employees added. Include any Subcontractors
          here, we'll keep them separate for payroll and tax purposes
        </Typography>
      </Box>
    </Box>
    <Box sx={{ 
      width: { xs: "100%", sm: "auto" }, // Make container full width on mobile
      display: "flex",
      justifyContent: { xs: "center", sm: "flex-start" }, // Center on mobile
      ml: { xs: 0, sm: 8 }, // Remove left margin on mobile
      mt: { xs: 2, sm: 0 } // Add top margin on mobile
    }}>
      <Button
        variant="contained"
        color="main"
        startIcon={<AddIcon />}
        sx={{
          flexWrap: "nowrap",
          whiteSpace: "nowrap",
          width: { xs: "100%", sm: "auto" } // Full width on mobile
        }}
        onClick={handleOpenAddEmpDlg}
      >
        New Employee
      </Button>
    </Box>
  </Box>
</Grid>
          {displayBanner && (
            <Grid item xs={12}>
              <Box 
                sx={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  justifyContent: 'space-between',
                  backgroundColor: 'rgb(35, 162, 109, 0.1)',
                  fontSize: '13px',
                  borderRadius: 1,
                  p: 2,
                  maxWidth: {xs: '100%', lg: '60%'},
                  mx: 'auto'
                }}
              >
                <ul style={{ lineHeight: '1.6' }}>
                  <li>Remember, you can add them all. You're only billed for the ones you invite as Users.</li>
                  <li>If they aren't logging into Cleri, even Users will be listed as “Inactive” automatically. Zero charge for Inactive Users.</li>
                  <li>Each User can only be logged in to one Desktop and one Mobile device at the same time.</li>
                </ul>
                <Tooltip title='Remove'>
                  <IconButton onClick={ () => setDisplayBanner(false)}>
                    <Icon icon='tabler:x' />
                  </IconButton>
                </Tooltip>
              </Box>
            </Grid>
          )}
          <Grid item xs={12}>
            <TabContext value={alignment}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <TabList
                  onChange={handleAlignment}
                  aria-label="customized tabs example"
                >
                  <Tab value="enterManually" label="Enter Manually" />
                  <Tab value="uploadFile" label="Import Employees" />
                </TabList>
              </Box>
              <TabPanel value="enterManually" sx={{ px: 0 }}>
                {rows && rows.length > 0 ? (
                  <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <DataGridPro
                      columns={columns}
                      rows={rows}
                      pageSizeOptions={[10, 25, 50, {label: 'Show All', value: rows.length}]}
                      paginationModel={employeePaginationModel}
                      onPaginationModelChange={setEmployeePaginationModel} 
                      processRowUpdate={(newRow, oldRow) =>
                        handleProcessRowUpdate(newRow, oldRow)
                      }
                      onProcessRowUpdateError={(error) => console.error(error)}
                      experimentalFeatures={{ newEditingApi: true }}
                      sx={{
                        "& .MuiDataGrid-columnHeaderTitle": {
                          textTransform: "none",
                        },
                        minHeight: 250,
                        maxHeight: 350,
                        maxWidth: {xs: '100%', lg: '60%'},
                      }}
                    />
                  </Box>
                ) : (
                  <Box 
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      mx: 'auto',
                      border: '1px solid #EAEAEA',
                      borderRadius: 1,
                      maxWidth: {xs: '100%', lg: '60%'},
                      py: 4,
                    }}
                  >
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                      <img src={AddEmployeeDoodle} />
                      <Typography variant='h6'>No Employees added yet</Typography>
                    </Box>
                  </Box>
                )}
              </TabPanel>
              <TabPanel value="uploadFile">
                <Grid item xs={12} sx={{ mb: 4 }}>
                  {/* <Card sx={{ cursor: "pointer" }}>
                    <CardContent sx={{ p: 10, flexGrow: 1, width: "100%" }}> */}
                    <Box
                      sx={{
                        border: '1px dashed #CACFD8',
                        borderRadius: 1,
                        py: 6,
                        px:{ xs: 2, sm: 6 },
                        maxWidth: {xs: '100%', lg: '60%'},
                        mx: 'auto',
                        cursor: 'pointer',
                      }}
                    >
                      <Fragment>
                        <div {...getRootProps({ className: "dropzone" })}>
                          <input {...getInputProps()} />
                          <Box
                            sx={{
                              display: "flex",
                              textAlign: "center",
                              alignItems: "center",
                              flexDirection: "column",
                              gap: 2,
                            }}
                          >
                            <Box
                              textAlign="center"
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                height: "100%", // Ensure it takes full height of parent
                                gap: 2, // Adds spacing between items (optional)
                              }}
                            >
                              <Icon icon="tabler:cloud-upload" fontSize="2.5rem" />
                            </Box>
                            <Typography variant="h6">
                              Import multiple Employees by uploading an Excel Spreadsheet or CSV file
                            </Typography>
                            <Typography variant="body2">
                              Click here to browse the files or drag your file here
                            </Typography>
                          </Box>
                        </div>
                      </Fragment>
                    </Box>
                    <Box>
                      {files.length ? (
                        <>
                          <List>{fileList}</List>
                        </>
                      ) : null}
                    </Box>
                    {/* </CardContent>
                  </Card> */}
                </Grid>
              </TabPanel>
            </TabContext>
          </Grid>
         <Grid item xs={12}>
 <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      width: "100%",
    }}
  >
    <Box
      sx={{
        display: "flex",
        flexDirection: "row", // same everywhere
        justifyContent: "space-between",
        alignItems: "center",
        width: { xs: "100%", lg: "60%" },
        gap: 2,
      }}
    >
      <Button
        variant="text"
        color='secondary'
        onClick={handlePrevious}
        
        sx={{ 
          "& svg": { mr: 2 },
        
        }}
      >
        {/* <Icon fontSize="1.125rem" icon="tabler:arrow-left" /> */}
        Previous
      </Button>
      <Box sx={{ 
        display: "flex", 
        flexDirection: "row",
        gap: { xs: 2, sm: 0 },
      
      }}>
        <Button
          variant="text"
          color='secondary'
          onClick={handleNextPage}
          size="small"
          sx={{ 
            mr: { xs: 0, sm: 2 }, // Remove right margin on mobile
          
          }}
          disabled={loading}
        >
          Skip for now
        </Button>
        <Button
          variant="contained"
          color="main"
          disabled={loading}
          onClick={
            dataEntryAlignment === "uploadFile"
              ? handleFileParse
              : handleNextPage
          }
          sx={{ 
          
          }}
        >
          {dataEntryAlignment === "enterManually" ? "Next" : "Import"}
        </Button>
      </Box>
    </Box>
  </Box>
</Grid>
        </Grid>
      </Box>

      <AddEmployeeDialog
        open={openAddEmpDlg}
        handleClose={handleCloseAddEmpDlg}
        fetchEmployees={fetchEmployees}
      />

      {/*<ToastContainer />*/}

      {/* Error List Dialog */}
      <Dialog
        fullWidth={true}
        maxWidth="md"
        open={openErrorListDlg}
        onClose={handleCloseErrorListDlg}
        aria-labelledby="form-dialog-title"
        sx={{
          "& .MuiDialog-paper": {
            maxWidth: "650px", // Custom maxWidth between sm and md
            width: "100%", // Ensures it’s responsive within the set max width
          },
        }}
      >
        <DialogTitle>
          <Typography variant="h4" fontWeight="bold">
            Save Unsuccessful
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={5}>
            <Grid item xs={12}>
              <Typography variant="button">
                The following employees will be skipped due to the reasons
                listed below.
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <DataGridPro
                autoHeight
                rows={errorMessages}
                getRowId={(row) => row.id}
                columns={errorColumns}
                sx={{
                  "& .MuiDataGrid-columnHeaderTitle": {
                    textTransform: "none",
                    fontWeight: "bold",
                  },
                  maxWidth: "600px",
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
          sx={{ display: "flex", justifyContent: "flex-end" }}
          className="dialog-actions-dense"
        >
          <Button
            variant="contained"
            color="main"
            onClick={handleCloseErrorListDlg}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

      {/* Success List Dialog */}
      <Dialog
        fullWidth={true}
        maxWidth="xs"
        open={openSuccessListDlg}
        onClose={handleCloseSuccessListDlg}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle>
          <Typography variant="h4" fontWeight="bold">
            Employee Import Success
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Fragment>{successMessages}</Fragment>
        </DialogContent>
        <DialogActions
          sx={{ display: "flex", justifyContent: "flex-end" }}
          className="dialog-actions-dense"
        >
          <Button
            variant="contained"
            color="main"
            onClick={handleCloseSuccessListDlg}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default StepAddEmployee;
